<template>
    <div class="row pt-2 opened-settings-block">
        <div class="col-12 mt-4 p-lr-0-sm user-settings-block">
            <div class="fast-actions-block pl-3 pr-3 pl-3 pr-3 pt-3 pb-2 max-h-165vh">
                <div class="dis-flex flex-column min-h-full">
                    <div class="pt-2 dis-flex flex-sb flex-b">
                        <button type="button" class="btn btn-element mb-3 w-full text-sm-d" @click="$emit('modifySettingsSelectedMenu', null)">
                            <i class="uis uis-channel mr-3 text-blue fs-16"></i>Sessions List
                            <span class="uim-svg ml-auto fs-16" title="Close List">
                                <svg viewBox="0 0 24 24" width="1em">
                                    <path class="uim-primary-w" d="M13.41406,12l2.293-2.293A.99989.99989,0,0,0,14.293,8.293L12,10.58594,9.707,8.293A.99989.99989,0,0,0,8.293,9.707L10.58594,12,8.293,14.293A.99989.99989,0,1,0,9.707,15.707L12,13.41406l2.293,2.293A.99989.99989,0,0,0,15.707,14.293Z"></path>
                                    <path class="uim-tertiary-g" d="M19,2H5A3.00328,3.00328,0,0,0,2,5V19a3.00328,3.00328,0,0,0,3,3H19a3.00328,3.00328,0,0,0,3-3V5A3.00328,3.00328,0,0,0,19,2ZM15.707,14.293A.99989.99989,0,1,1,14.293,15.707L12,13.41406,9.707,15.707A.99989.99989,0,0,1,8.293,14.293L10.58594,12,8.293,9.707A.99989.99989,0,0,1,9.707,8.293L12,10.58594l2.293-2.293A.99989.99989,0,0,1,15.707,9.707L13.41406,12Z"></path>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div class="content-crds-messages-scroll pos-relative pt-2 mt-2">
                        <div class="col-sm-12 p-lr-0-sm session-card-wrapper mb-3" v-for="thisLoginSession in sessionsList" :key="thisLoginSession.uid">
                            <div class="dis-flex flex-m flex-sb pos-relative">
                                <div class="dis-flex flex-m w-full">
                                    <small class="col-4 fs-13 p-0 text-right">Session:</small>
                                    <span class="col-8 text-sm-d pr-0">{{ thisLoginSession.uid }}</span>
                                </div>
                                <div class="pos-absolute p-right-0" title="Current Session" v-if="thisLoginSession.isCurrentSession">
                                    <span class="uim-svg fs-16"><svg viewBox="0 0 24 24" width="1em"><path class="uim-primary-w" d="M10.3125,16.09375a.99676.99676,0,0,1-.707-.293L6.793,12.98828A.99989.99989,0,0,1,8.207,11.57422l2.10547,2.10547L15.793,8.19922A.99989.99989,0,0,1,17.207,9.61328l-6.1875,6.1875A.99676.99676,0,0,1,10.3125,16.09375Z" opacity=".99"></path><path class="uim-tertiary-gr" d="M12,2A10,10,0,1,0,22,12,10.01146,10.01146,0,0,0,12,2Zm5.207,7.61328-6.1875,6.1875a.99963.99963,0,0,1-1.41406,0L6.793,12.98828A.99989.99989,0,0,1,8.207,11.57422l2.10547,2.10547L15.793,8.19922A.99989.99989,0,0,1,17.207,9.61328Z"></path></svg></span>
                                </div>
                                <span class="uim-svg ml-auto fs-16 pointer pos-absolute p-right-0" title="Terminate Session" v-else @click="closeSelectedLoginSession(thisLoginSession.uid)"><svg viewBox="0 0 24 24" width="1em"><path class="uim-primary-r" d="M12,2A10,10,0,1,0,22,12,10.01177,10.01177,0,0,0,12,2Zm8,10a7.951,7.951,0,0,1-1.68835,4.89758L7.10242,5.68835A7.98659,7.98659,0,0,1,20,12ZM4,12A7.951,7.951,0,0,1,5.68835,7.10242L16.89758,18.31165A7.98659,7.98659,0,0,1,4,12Z"></path></svg></span>
                            </div>
                            <div class="dis-flex flex-m w-full">
                                <small class="col-4 fs-13 p-0 text-right">Login IP:</small>
                                <span class="col-8 text-sm-d pr-0">{{ thisLoginSession.ip }}</span>
                            </div>
                            <div class="dis-flex flex-m w-full">
                                <small class="col-4 fs-13 p-0 text-right">Last used IP:</small>
                                <span class="col-8 text-sm-d pr-0">{{ thisLoginSession.last_ip }}</span>
                            </div>
                            <div class="dis-flex flex-m w-full" v-if="thisLoginSession.moreData.device && thisLoginSession.moreData.device.model">
                                <small class="col-4 fs-13 p-0 w-full text-right">Device:</small>
                                <span class="col-8 text-sm-d pr-0"><span v-if="thisLoginSession.moreData.device.vendor">{{ thisLoginSession.moreData.device.vendor }}&nbsp;</span>{{ thisLoginSession.moreData.device.model }}</span>
                            </div>
                            <div class="dis-flex flex-m w-full" v-else-if="thisLoginSession.moreData.additional_device">
                                <small class="col-4 fs-13 p-0 text-right">Device:</small>
                                <span class="col-8 text-sm-d pr-0">{{ thisLoginSession.moreData.additional_device }}</span>
                            </div>
                            <div class="dis-flex flex-m w-full" v-if="thisLoginSession.moreData.os && thisLoginSession.moreData.os.name">
                                <small class="col-4 fs-13 p-0 text-right">OS:</small>
                                <span class="col-8 text-sm-d pr-0">{{ thisLoginSession.moreData.os.name }} {{ thisLoginSession.moreData.os.version }}</span>
                            </div>
                            <div class="dis-flex flex-m w-full">
                                <small class="col-4 fs-13 p-0 text-right">Last used:</small>
                                <span class="col-8 text-sm-d pr-0">{{ getDateStringFromDate(new Date(thisLoginSession.lastUsed), true) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateMixin from "@/mixins/dateMixin"

export default {
    mixins: [dateMixin],
    data() {
        return {
            sessionsList: [],
        }
    },
    mounted() {
        getMyLoginSessions(this)
    },
    methods: {
        closeSelectedLoginSession: function(sessionUID) {
            let thisCompVue = this
            socket.emit('closeSelectedLoginSession', sessionUID, function(response) {
                if (response === true) {
                    getMyLoginSessions(thisCompVue)
                }
            })
        }
    }
}

function getMyLoginSessions(thisCompVue) {
    socket.emit('getMyLoginSessions', function(response) {
        let thisCookiesLoginToken = Cookies.get('adlgn_t')
        response.forEach(function(session) {
            if (thisCookiesLoginToken.startsWith(session.uid)) {
                session.isCurrentSession = true
            }
        })

        thisCompVue.sessionsList = response;
        console.log(response)
    });
}

</script>

<style>

</style>